export default "__VITE_ASSET__C9L68FD___"